module.exports = __webpack_public_path__ + "static/seres-silk-duvet-3-3e0f0dd7ff4a679ec36590e3d5011a52.png";